import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-arr-up",
  "use": "icon-arr-up-usage",
  "viewBox": "0 0 24 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 28\" id=\"icon-arr-up\"><path d=\"M24 10.4l-1.4 1.8-1.4 1.8-2-1.8-5-4.4V28H10V7.6l-5.4 4.6-2 1.8-1.2-1.8L0 10.4 12 0l12 10.4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol